import { render, staticRenderFns } from "./BulletList.vue?vue&type=template&id=5f92715a&"
import script from "./BulletList.vue?vue&type=script&lang=ts&"
export * from "./BulletList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f92715a')) {
      api.createRecord('5f92715a', component.options)
    } else {
      api.reload('5f92715a', component.options)
    }
    module.hot.accept("./BulletList.vue?vue&type=template&id=5f92715a&", function () {
      api.rerender('5f92715a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/ob1/BulletList.vue"
export default component.exports